export enum EnumHold {
  Libre = 1,
  Aviso = 2,
  Bloqueado = 3
}
